import { render, staticRenderFns } from "./LayoutVerticalCustom.vue?vue&type=template&id=494a2a08&scoped=true&"
import script from "./LayoutVerticalCustom.vue?vue&type=script&lang=js&"
export * from "./LayoutVerticalCustom.vue?vue&type=script&lang=js&"
import style0 from "./LayoutVerticalCustom.vue?vue&type=style&index=0&id=494a2a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a2a08",
  null
  
)

export default component.exports